(() => {
  'use strict';

  function initGallerySlider(root) {
    if (!root || root.dataset.gallerySliderBound === 'true') return;
    root.dataset.gallerySliderBound = 'true';

    const mainSlides = root.querySelectorAll('[data-gallery-main-slide]');
    const thumbs = root.querySelectorAll('[data-gallery-thumb]');
    const thumbsList = root.querySelector('.main-shaped__gallery-slider__thumbs');
    if (!mainSlides.length || !thumbs.length) return;

    let activeIndex = 0;
    let autoplayInterval = null;
    let autoplayPaused = false;
    let autoplayStopped = false;

    const scrollToThumb = (index) => {
      if (!thumbsList) return;
      const thumb = thumbs[index];
      if (!thumb) return;

      thumb.scrollIntoView({ block: 'nearest', behavior: 'smooth' });

      if (thumbs.length <= 4 || (index !== 2 && index !== 3)) return;

      const maxScroll = thumbsList.scrollHeight - thumbsList.clientHeight;
      if (maxScroll <= 0) return;

      window.setTimeout(() => {
        const remaining = maxScroll - thumbsList.scrollTop;
        if (remaining <= 1) return;

        const nudge = Math.min(thumbsList.clientHeight * 0.25, remaining);
        thumbsList.scrollBy({ top: nudge, behavior: 'smooth' });
      }, 150);
    };

    const setActive = (index) => {
      if (index < 0 || index >= thumbs.length) return;
      activeIndex = index;

      mainSlides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });
      thumbs.forEach((thumb, i) => {
        const isActive = i === index;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      scrollToThumb(index);
    };

    const pauseAutoplay = () => {
      autoplayPaused = true;
    };

    const resumeAutoplay = () => {
      if (!autoplayStopped) autoplayPaused = false;
    };

    const stopAutoplay = () => {
      autoplayStopped = true;
      autoplayPaused = true;
      if (autoplayInterval) {
        window.clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    };

    const startAutoplay = () => {
      if (root.dataset.autoplay !== 'true' || thumbs.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const speed = Number.parseInt(root.getAttribute('data-autoplay-speed') || '5', 10);
      const autoplaySpeed = speed * 1000;

      autoplayInterval = window.setInterval(() => {
        if (autoplayPaused || autoplayStopped) return;
        const nextIndex = activeIndex + 1 >= thumbs.length ? 0 : activeIndex + 1;
        setActive(nextIndex);
      }, autoplaySpeed);

      root.addEventListener('mouseenter', pauseAutoplay);
      root.addEventListener('mouseleave', resumeAutoplay);
      root.addEventListener('focusin', pauseAutoplay);
      root.addEventListener('focusout', resumeAutoplay);

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            resumeAutoplay();
          } else {
            pauseAutoplay();
          }
        });
      }, { threshold: 0.25 });

      observer.observe(root);
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = Number.parseInt(thumb.getAttribute('data-gallery-thumb'), 10);
        if (Number.isNaN(index)) return;
        stopAutoplay();
        setActive(index);
      });
    });

    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-gallery-slider]').forEach(initGallerySlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
